import { Instagram, ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { LIFESTYLE_3 } from "../lib/assets";

export const Community = () => {
  const { t } = useLanguage();

  return (
    <section
      id="community"
      data-testid="community-section"
      className="relative overflow-hidden py-24 md:py-32 bg-gradient-to-b from-black via-zinc-950 to-black"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="relative aspect-[4/5] lg:aspect-[5/6]">
          <img
            src={LIFESTYLE_3}
            alt="Cabo community"
            className="w-full h-full object-cover image-cinematic"
          />
          <div className="absolute -bottom-4 -left-4 bg-yellow-400 text-black px-6 py-4">
            <p className="font-display text-3xl uppercase leading-none">#CABO</p>
            <p className="font-display text-3xl uppercase leading-none">UNSTOPPABLE</p>
          </div>
        </div>

        <div className="min-w-0">
          <p className="overline mb-5">{t.community.overline}</p>
          <h2 className="h-display text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl break-words">
            {t.community.title}
          </h2>
          <p className="text-white/70 mt-6 max-w-lg leading-relaxed">
            {t.community.subtitle}
          </p>

          <a
            href="https://www.instagram.com/cabounstoppable/"
            target="_blank"
            rel="noreferrer"
            data-testid="community-cta"
            className="mt-10 btn-cabo btn-cabo--yellow"
          >
            <Instagram className="w-4 h-4" />
            {t.community.cta}
            <ArrowUpRight className="w-3.5 h-3.5 btn-arrow" />
          </a>
        </div>
      </div>
    </section>
  );
};
